import { render } from "./Discount.vue?vue&type=template&id=715030f8"
import script from "./Discount.vue?vue&type=script&lang=js"
export * from "./Discount.vue?vue&type=script&lang=js"
script.render = render

export default script